import { useTheme } from '@/components/ThemeProvider';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuCheckboxItem, DropdownMenuContent, DropdownMenuTrigger } from '@/components/ui/dropdown-menu';
import { Filter } from '@/widget/Icon';
import { useTranslation } from 'react-i18next';

type TradeType = 'buy' | 'sell' | 'all';

interface IProps {
  tradeType: TradeType;
  setTradeType: (type: TradeType) => void;
}
export default (props: IProps) => {
  const { tradeType, setTradeType } = props;
  const { t } = useTranslation();
  const { theme } = useTheme();
  return (
    <div className="h-[32px] bg-primaryBgColor text-[14px] text-secondaryTextColor flex items-center z-10 sticky top-0 left-0 right-0">
      <div className="flex-1">
        <div className="flex items-center">
          <span>{t('Account.type')}</span>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="w-[18px] h-[18px] p-0 flex justify-center items-center">
                <Filter className="w-[18px] h-[18px]" theme={theme} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent>
              <DropdownMenuCheckboxItem checked={tradeType === 'all'} onCheckedChange={() => setTradeType('all')}>
                <span>{t('Account.all')}</span>
              </DropdownMenuCheckboxItem>
              <DropdownMenuCheckboxItem checked={tradeType === 'buy'} onCheckedChange={() => setTradeType('buy')}>
                <span>{t('Account.buy')}</span>
              </DropdownMenuCheckboxItem>
              <DropdownMenuCheckboxItem checked={tradeType === 'sell'} onCheckedChange={() => setTradeType('sell')}>
                <span>{t('Account.sell')}</span>
              </DropdownMenuCheckboxItem>
            </DropdownMenuContent>
          </DropdownMenu>
          <span>/{t('Account.time')}</span>
        </div>
      </div>
      <div className="flex-1">
        <div className="flex items-center justify-center">{t('Account.token')}</div>
      </div>
      <div className="flex-1 text-right">
        <span>
          {t('Account.value')}/{t('Account.price')}
        </span>
      </div>
    </div>
  );
};
